import { render } from "./MyOrderPage.vue?vue&type=template&id=2fee41d2&scoped=true"
import script from "./MyOrderPage.vue?vue&type=script&lang=js"
export * from "./MyOrderPage.vue?vue&type=script&lang=js"

import "./MyOrderPage.vue?vue&type=style&index=0&id=2fee41d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fee41d2"]])

export default __exports__